import { Configuration } from '@content-platform/web-angular-shared-util-configuration';
function getEndpoint(endpoint) {
    const config = Configuration.get('adal');
    if (config && config.endpoints) {
        return config.endpoints[endpoint];
    }
}
export function endpointNeedsAdalToken(request) {
    return !!getAdalEndpoint(request);
}
export function getAdalEndpoint(request) {
    const adalEndpoints = Object.keys((Configuration.get('adal') || {}).endpoints || {});
    const adalEndpointId = adalEndpoints.reduce((idSoFar, currentEndpoint) => idSoFar || (request.url.startsWith(currentEndpoint) ? getEndpoint(currentEndpoint) : ''), '');
    return adalEndpointId;
}
//# sourceMappingURL=endpoint-helper.js.map